export enum QuestionStatus {
    CANDIDATE = 'CANDIDATE',
    ACTIVE = 'ACTIVE',
    RETIRED = 'RETIRED',
    NEW_VERSION = 'NEW_VERSION'
}
